import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { CardMenu } from '@/components/ui/card';
    import { columns } from '@/tables/columns/holidays';
    import { Head } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateHoliday from '@/components/holidays/CreateHoliday.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem, NavItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Holidays',
  setup(__props) {

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'menu.salary_setup',
        },
    ];

    const navItems: NavItem[] = [
        {
            title: 'holidays.page_header',
            href: route('v2.salary.holidays.index'),
            permissionLevel: Permission.HOLIDAYS_VIEW,
        },
        {
            title: 'work-calendars.page_header',
            href: route('v2.salary.work-calendars.index'),
            permissionLevel: Permission.WORK_CALENDARS_VIEW,
        },
    ];

    const { isPending, data } = useQuery({
        queryKey: [QueryKey.HOLIDAYS],
        queryFn: getHolidays,
    });

    async function getHolidays() {
        const { data } = await axios.get(route('v2.salary.holidays.table'));
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('holidays.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "header-class": "w-full"
    }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).HOLIDAYS,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "default-sorting": [
                    {
                        id: 'name',
                        desc: false,
                    },
                ]
            }, _createSlots({
              title: _withCtx(() => [
                _createVNode(_unref(CardMenu), { items: navItems })
              ]),
              _: 2
            }, [
              (_unref(hasPermission)(_unref(Permission).HOLIDAYS_CREATE))
                ? {
                    name: "actions",
                    fn: _withCtx(() => [
                      _createVNode(DataTableToolbarActions, { name: "holidays" }, {
                        default: _withCtx(() => [
                          (_unref(hasPermission)(_unref(Permission).HOLIDAYS_CREATE))
                            ? (_openBlock(), _createBlock(CreateHoliday, { key: 0 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["table-key", "columns", "data", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})